// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  launchId: __t.u64().primaryKey().name("launch_id"),
  worldId: __t.u64().name("world_id"),
  x: __t.f32(),
  y: __t.f32(),
  z: __t.f32(),
  kind: __t.string(),
  palette: __t.u8(),
  seed: __t.u32(),
  by: __t.identity(),
  at: __t.timestamp(),
});
